// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { cartLinesListHeaderStyles } from "@awc/Overrides/Components/CartLinesListHeader";
import { TypographyProps } from "@insite/mobius/Typography";
import { css } from "styled-components";

cartLinesListHeaderStyles.wrapper = {
    css: css`
        display: flex;
        justify-content: space-between;
    `,
};

cartLinesListHeaderStyles.productCountText = {
    variant: "h3",
    as: "h2",
    css: css`
        margin-bottom: 12px;
    `,
} as TypographyProps;
